import PraticaRow from '@/components/elements/pratica/PraticaRow.vue'
import PraticaPage from '@/components/views/PraticaPage.vue'
import ETPraticaRow from '@/components/elements/pratica/express-trailers/ETPraticaRow.vue'
import ETPraticaPage from '@/components/elements/pratica/express-trailers/ETPraticaPage.vue'
import AdminSettingsExpress from '@/components/views/AdminSettingsExpress.vue'

// Company parameter holding the layout key of the user's company
export const COMPANY_LAYOUT_PARAM = 'COMPANY_LAYOUT'
export const DEFAULT_LAYOUT = 'default'

// Components used by each layout: the dashboard row, the shipment detail page
// and the admin settings page (null keeps the standard one).
export const COMPANY_LAYOUTS = {
  'default': {
    row: PraticaRow,
    page: PraticaPage,
    adminSettings: null,
  },
  'express-trailers': {
    row: ETPraticaRow,
    page: ETPraticaPage,
    adminSettings: AdminSettingsExpress,
  },
}

export function resolveLayout(key) {
  if (key && !COMPANY_LAYOUTS[key]) console.warn(`Unknown company layout "${key}", using "${DEFAULT_LAYOUT}"`)
  return COMPANY_LAYOUTS[key] || COMPANY_LAYOUTS[DEFAULT_LAYOUT]
}
